import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

const CalendlyBooking = () => {
  const { t } = useTranslation();

  useEffect(() => {
    // Load Calendly widget script
    const script = document.createElement("script");
    script.src = "https://assets.calendly.com/assets/external/widget.js";
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script when component unmounts
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-100">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="aai-section-title mb-5 text-center">
              <h2 className="section-title">{t("calendly.page_title")}</h2>
              <p className="section-desc">{t("calendly.page_subtitle")}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-12">
            {/* Calendly inline widget */}
            <div
              className="calendly-inline-widget"
              data-url="https://calendly.com/elias-elmurr-1990"
              style={{ minWidth: "320px", height: "700px" }}
            ></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CalendlyBooking;
